import { SDKAction, sdk as squareSdk } from '@squareup/sq-addons-web-sdk'
import { useEffect } from 'react'
import { t } from 'react-i18nify'

const callbacks = {
  [SDKAction.SDK_GET_ADDON_INFO]: () => ({ title: t('general.appName') }),
}

const ActionSlot = () => {
  useEffect(() => {
    const registerGetAddonInfoCallback = async () => {
      await squareSdk.initialize(callbacks)
    }

    registerGetAddonInfoCallback()
  }, [])

  return <></>
}

export default ActionSlot
